/* *
 * ========================================================================
 * Vortex Solution
 * ========================================================================
 * */

// Includes the custom Modernizr build based on the configurations set in .modernizrrc
require('Modernizr'); // eslint-disable-line import/no-extraneous-dependencies
require('nodelist-foreach-polyfill');
require('element-qsa-scope');
require('./main/dropdown-menu');
require('./main/mobile-menu');
require('./main/user-is-tabbing');
require('./main/forms');
require('./main/search-modal');
require('./main/breadcrumbs');
require('./main/font-size-variator');
require('./main/video-player');
require('./main/multiple-file-upload');
require('./main/ajax-form');
require('./main/decompte');
require('./main/video-html');
require('./main/custom-filter');
require('./main/custom-dropdown');

import domReady from '@wordpress/dom-ready';

domReady(() => {
  console.log('Dom is ready');
});
